import _sfc_main from './UiButtonGroup.vue2.js';
import normalizeComponent from '../../_virtual/_plugin-vue2_normalizer.js';

var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { staticClass: "fds-ui-button-group" }, [_vm._t("root", function() {
    return [_vm._l(_vm.buttons, function(button) {
      return [_vm._t("button", function() {
        return [_c("button", { key: `button-group-item-${button.key}`, staticClass: "fds-ui-button fds-ui-button-group__item", class: { "fds-ui-button-group__item--active": _setup.isButtonActive(button) }, attrs: { "type": "button", "disabled": _setup.isButtonDisabled(button) }, on: { "click": function($event) {
          return _setup.changeActiveButton(button);
        } } }, [_vm._v(" " + _vm._s(button.label) + " ")])];
      }, null, { buttons: _vm.buttons, button, isButtonActive: _setup.isButtonActive, isButtonDisabled: _setup.isButtonDisabled, changeActiveButton: _setup.changeActiveButton })];
    })];
  }, null, { buttons: _vm.buttons, isButtonActive: _setup.isButtonActive, isButtonDisabled: _setup.isButtonDisabled, changeActiveButton: _setup.changeActiveButton })], 2);
};
var _sfc_staticRenderFns = [];
_sfc_render._withStripped = true;
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null,
  null,
  null
);
__component__.options.__file = "/home/ubuntu/actions-runner/_work/library/library/packages/library/src/components/ui-button-group/UiButtonGroup.vue";
var UiButtonGroup = __component__.exports;

export { UiButtonGroup as default };
